<template>
  <exercicio></exercicio>
</template>

<script>
import exercicio from '@/custom/exercicio'
var componentDefinition = {
  components: { exercicio },
  route: {
    name: 'ASSERTIVAS',
    path: '/aluno/:idaluno/matricula/:idmatricula/bloco/:idbloco/assertivas/:refresh?',
    meta: {
      title: 'Verdadeiro ou Falso',
      hasErrorHandler: true,
      hidden: true
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  data: function () {
    return {}
  },
  methods: {
  }
}
export default componentDefinition
</script>
